(() => {
  const retiredViews = new Set(['view-24', 'view-36', 'view-48']);
  const isRetired = (name, value) => name === 'grid_list' || (name === 'view' && retiredViews.has(value));

  function clean(url) {
    const entries = Array.from(url.searchParams);
    const retained = entries.filter(([name, value]) => !isRetired(name, value));
    if (retained.length !== entries.length) {
      url.search = new URLSearchParams(retained).toString();
    }
    return url;
  }

  function isCollectionPage(url) {
    return url.origin === window.location.origin && /\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname) && !url.pathname.includes('/products/');
  }

  function cleanLocation() {
    const url = clean(new URL(window.location.href));
    if (url.href !== window.location.href) {
      window.history.replaceState(window.history.state, '', url.href);
    }
  }

  function cleanElement(element) {
    const attribute = element.matches('a[href]') ? 'href' : element.matches('form') ? 'action' : null;
    if (!attribute) {
      return;
    }
    const original = element.getAttribute(attribute) || window.location.href;
    let url;
    try {
      url = new URL(original, window.location.href);
    } catch {
      return;
    }
    if (!isCollectionPage(url)) {
      return;
    }
    const before = url.href;
    clean(url);
    if (before !== url.href) {
      element.setAttribute(attribute, `${url.pathname}${url.search}${url.hash}`);
    }
    if (attribute === 'action') {
      element.querySelectorAll('input[name]').forEach(input => {
        if (isRetired(input.name, input.value)) {
          input.remove();
        }
      });
    }
  }

  function cleanTree(root) {
    if (root.nodeType === 1) {
      cleanElement(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('a[href], form').forEach(cleanElement);
    }
  }

  window.TBSCollectionUrls = { clean };
  cleanLocation();
  window.addEventListener('popstate', cleanLocation);
  document.addEventListener('DOMContentLoaded', () => {
    cleanTree(document);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') {
          cleanElement(record.target);
        } else {
          record.addedNodes.forEach(cleanTree);
        }
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action'] });
  }, { once: true });
  document.addEventListener('submit', event => cleanElement(event.target), true);
  document.addEventListener('formdata', event => {
    const url = new URL(event.target.action || window.location.href, window.location.href);
    if (!isCollectionPage(url)) {
      return;
    }
    const entries = Array.from(event.formData);
    const names = new Set(entries.filter(([name, value]) => isRetired(name, value)).map(([name]) => name));
    names.forEach(name => {
      event.formData.delete(name);
      entries.filter(([key, value]) => key === name && !isRetired(key, value)).forEach(([key, value]) => event.formData.append(key, value));
    });
  });
})();
